import React from 'react';

export default function TransactionIcon() {
  return (
    <svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1">
      <title>User Management</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="Artboard" transform="translate(-296.000000, -44.000000)">
          <path
            d="M310.5,51 C311.88,51 312.99,49.88 312.99,48.5 C312.99,47.12 311.88,46 310.5,46 C309.12,46 308,47.12 308,48.5 C308,49.88 309.12,51 310.5,51 Z M303,50 C304.66,50 305.99,48.66 305.99,47 C305.99,45.34 304.66,44 303,44 C301.34,44 300,45.34 300,47 C300,48.66 301.34,50 303,50 Z M310.5,53 C308.67,53 305,53.92 305,55.75 L305,58 L316,58 L316,55.75 C316,53.92 312.33,53 310.5,53 Z M303,52 C300.67,52 296,53.17 296,55.5 L296,58 L303,58 L303,55.75 C303,54.9 303.33,53.41 305.37,52.28 C304.5,52.1 303.66,52 303,52 Z"
            id="path-1"></path>
        </g>
      </g>
    </svg>
  );
}
